var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.5V20.5H18.5V21.5H1.5V10.5H2.5ZM22.5 6.5V17.5H5.5V6.5H22.5ZM14 9.5C14.663 9.5 15.2987 9.76358 15.7676 10.2324C16.2364 10.7013 16.5 11.337 16.5 12C16.5 12.663 16.2364 13.2987 15.7676 13.7676C15.2987 14.2364 14.663 14.5 14 14.5C13.337 14.5 12.7013 14.2364 12.2324 13.7676C11.7636 13.2987 11.5 12.663 11.5 12C11.5 11.337 11.7636 10.7013 12.2324 10.2324C12.7013 9.76358 13.337 9.5 14 9.5ZM21.5 9.5H21C20.6022 9.5 20.2208 9.34185 19.9395 9.06055C19.6581 8.77924 19.5 8.39782 19.5 8V7.5H8.5V8C8.5 8.39782 8.34185 8.77924 8.06055 9.06055C7.77924 9.34185 7.39782 9.5 7 9.5H6.5V14.5H7C7.39782 14.5 7.77924 14.6581 8.06055 14.9395C8.34185 15.2208 8.5 15.6022 8.5 16V16.5H19.5V16C19.5 15.6022 19.6581 15.2208 19.9395 14.9395C20.2208 14.6581 20.6022 14.5 21 14.5H21.5V9.5Z",
    fill: "#0087FE",
    stroke: "#0087FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice);
export default __webpack_public_path__ + "static/media/price.163839a21bd86e6f7a56235e6dc2603e.svg";
export { ForwardRef as ReactComponent };